import { render, staticRenderFns } from "./nbn-check-list-details.vue?vue&type=template&id=146e8960&scoped=true"
import script from "./nbn-check-list-details.vue?vue&type=script&lang=js"
export * from "./nbn-check-list-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e8960",
  null
  
)

export default component.exports